export default __webpack_public_path__ + "static/media/017_photo.99bcf3ea.jpg";